import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("vc_token");
  return token ? children : <Navigate to="/dashboard/login" replace />;
};

export default PrivateRoute;
